import React, { useRef, useState } from "react";
import "./anecdotas.css";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import flecha_izq from "../../../assets/imgs/sobre_mi/flecha_izq.png";
import flecha_der from "../../../assets/imgs/sobre_mi/flecha_der.png";

import VideoPopup from "../../popup/videopopup";

import { Pagination, Navigation } from "swiper/modules";
import Slider from "../../../components/slider/Slider";

const Anecdotas = () => {
  const [t, i18n] = useTranslation("sobre_mi");
  const [isVideoPopupOpen, setVideoPopupOpen] = useState(false);
  const [currentVideoId, setCurrentVideoId] = useState(null);
  const swiperRef = useRef(null);

  // Function to handle the "Next" button click
  const handleNextButtonClick = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const openVideoPopup = (videoId) => {
    setCurrentVideoId(videoId);
    setVideoPopupOpen(true);
  };

  const closeVideoPopup = () => {
    setVideoPopupOpen(false);
  };

  // Function to handle the "Previous" button click
  const handlePrevButtonClick = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  return (
    <>
      <div className="video">
        <VideoPopup
          isOpen={isVideoPopupOpen}
          onClose={closeVideoPopup}
          videoURL={currentVideoId}
        />
      </div>
      <div className="SB_anecdotas">
        <div className="SB_anecdotas_titulo">
          <h2>{t("anecdotas.titulo")}</h2>
        </div>

        <Slider openVideoPopup={openVideoPopup} t={t} />
      </div>
    </>
  );
};

export default Anecdotas;
